import angular from 'angular';
import template from './template.html';
import './style.scss';

export class SkillsSection {
    isEditMode = false;

    /* @ngInject */
    constructor($scope, ModalDialogService) {
        this.$scope = $scope;
        this.ModalDialogService = ModalDialogService;
    }

    $onChanges() {
        this.setupCriteriaFieldsOptions();
    }

    setupCriteriaFieldsOptions() {
        this.criteriaOptions = {
            title: '',
            field: 'skills',
            type: 'dynamic',
            dropDownText: 'ADD_SKILL',
            subCriteria: null,
            multiple: true,
            selected: (this.skills || []).reduce((selectedSkills, value) => {
                if (value) {
                    selectedSkills.push({
                        uid: (value.skillId === '0') ? null : value.skillId,
                        value: value.skillName,
                        isDerived: value.isDerived,
                        required: 'optional',
                    });
                }

                return selectedSkills;
            }, []),
            setAsMandatory: false,
        };

        this.allData = [this.criteriaOptions];
    }

    openEditSkillsForm() {
        let isSent = true;
        if (this.currentCandidate) {
            const currentRecruiterStatus = this.currentCandidate.workflow.recruiterStatus.current;
            isSent = currentRecruiterStatus === 'Sent';
        }

        if ((this.showConfirmationBeforeEdit) && (isSent)) {
            this.ModalDialogService.showDialog({
                modalDialogId: 'showSkillsEditConfirmation',
                title: 'UPDATE_PROFILE_FOR_SUBMISSION_ALERT',
                body: 'UPDATE_PROFILE_FOR_SUBMISSION_ALERT_MESSAGE',
                showCancelButton: true,
                showCloseButton: true,
                cancelButtonClass: 'primary-button',
                onClose: () => {
                },
                buttons: [
                    {
                        label: 'CONTINUE',
                        className: 'default-button',
                        onClick: () => this.onEdit(),
                    },
                ],
            });
        } else {
            this.onEdit();
        }
    }

    onEdit() {
        this.setupCriteriaFieldsOptions();
        this.isEditMode = true;
    }

    closeEditSkillsForm() {
        this.isEditMode = false;
    }

    saveEditedSkills() {
        const sanitazeSelected = this.criteriaOptions.selected.map(value => {
            const newValue = angular.copy(value);
            newValue.uid = value.uid === '0' ? null : value.uid;
            return newValue;
        });

        this.criteriaOptions.selected = sanitazeSelected;

        this.onSkillsChange({ skills: this.criteriaOptions });

        this.closeEditSkillsForm();
    }
}

export const CandidateSkillsSectionCongifuration = {
    template,
    controller: SkillsSection,
    bindings: {
        skills: '<',
        canEdit: '<',
        currentCandidate: '<',
        showConfirmationBeforeEdit: '<',
        onSkillsChange: '&',
    },
    controllerAs: 'skillsSectionController',
};

angular.module('TALENYA-FE').component('candidateSkillsSection', CandidateSkillsSectionCongifuration);
